import MyNotifications from "./MyNotifications";

export default MyNotifications;
